import { defaultTheme } from '@sinoui/theme';
export default defaultTheme;
//# sourceMappingURL=defaultTheme.js.map